import { createTranslations } from '@npco/common-utils-translations'

export const contactOrBillerFieldTranslations = createTranslations({
  required: 'Select a Contact from the list or add a new Biller Code.',
})
